import { userSetupHeaderStyles } from "@insite/content-library/Widgets/UserSetup/UserSetupHeader";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { COLORS, TYPOGRAPHY } from "@tSurya/theme/design.surya";
import { css } from "styled-components";

userSetupHeaderStyles.assignShipToAddressButton = {
    variant: "secondary",
    css: css`
        display: none;
        margin-right: 10px;
        border-radius: 0;
        padding: 10px 34px;
        background: ${COLORS.background.main};
        border: 2px solid ${COLORS.primary.base} !important;
        font-family: ${TYPOGRAPHY.fontFamily.title};

        &:hover {
            background: ${COLORS.background.main};
            border: 2px solid ${COLORS.text.accent} !important;
        }

        span[class^="TypographyStyle"] {
            color: ${COLORS.text.main};
            font-size: 14px;
            line-height: ${TYPOGRAPHY.lineHeight.base};
            &:hover {
                color: ${COLORS.text.accent};
            }
        }
    `,
};
userSetupHeaderStyles.saveButton = {
    css: css`
        border-radius: 0;
        padding: 10px 34px;
        background: ${COLORS.primary.base};
        border: 2px solid ${COLORS.primary.base};
        font-family: ${TYPOGRAPHY.fontFamily.title};

        span[class^="TypographyStyle"] {
            font-size: 14px;
            line-height: ${TYPOGRAPHY.lineHeight.base};
            font-family: ${TYPOGRAPHY.fontFamily.title};
        }
        &:disabled {
            background-color: rgb(204, 204, 204) !important;
        }
        &:hover {
            background: ${COLORS.text.accent};
            /* border: 2px solid  background: ${COLORS.text.accent}; */
            span[class^="TypographyStyle"] {
                color:${COLORS.background.main};
            }
        }
    `,
};
userSetupHeaderStyles.cancelButton={
    buttonType:"outline",
    sizeVariant:'medium',
    css: css`
        margin-right: 10px;
        padding: 10px 21px;
        font-family: ${TYPOGRAPHY.fontFamily.title};
        span[class^="TypographyStyle"] {
        color:black;
            font-size: 14px;
            line-height: ${TYPOGRAPHY.lineHeight.base};
            font-family: ${TYPOGRAPHY.fontFamily.title};
        }
    `,
};
userSetupHeaderStyles.actionButtonsHidden = {
    css: css`
        font-family: ${TYPOGRAPHY.fontFamily.title};
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    button {
                        background: none !important;
                        font-family: ${TYPOGRAPHY.fontFamily.title};
                    }
                `,
                css`
                    button {
                        background: none !important;
                        font-family: ${TYPOGRAPHY.fontFamily.title};
                    }
                `,
                null,
                null,
                null,
            ])}
    `,
};
userSetupHeaderStyles.container ={
    gap: 8,
    css: css`
        padding-top: 40px;
        font-family: ${TYPOGRAPHY.fontFamily.title};

        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    padding-top: 0px;
                `,
                css`
                    padding-top: 0px;
                `,
                null,
                null,
                null,
            ])}
    `,
}

userSetupHeaderStyles.overflowMenu={
   cssOverrides:{
    wrapper:css`
        font-family: ${TYPOGRAPHY.fontFamily.title};
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    css`
                        display: none;
                    `,
                    null,
                    null,
                ])};
        `,
    menu:css`
    li:first-child{
        display: none ;
            }
    `
   }
}